import { WithStyles, withStyles } from '@mui/styles';

import { Alerts } from './alerts';
import { muiStyles } from './alertStyles';

export type AlertsProps = WithStyles<typeof muiStyles>;

export default withStyles(muiStyles)(Alerts);